module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/may/mainvisual-present-sp-buyback_abb41a8b1c225fcff86e319b9026b89d.png";